import { IonItemDivider, IonLabel, useIonViewWillEnter } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Template } from "../../../@types/template";

import { findUserTemplateList } from "../../../store/userTemplate/actions/findUserTemplateList";
import { selectUserTemplateList } from "../../../store/userTemplate/selectors/selectUserTemplateList";
import { UserTemplateItem } from "./UserTemplateItem";

export const UserTemplateListContainer = () => {
    const { id }: { id: string } = useParams();
  const dispatch = useDispatch();
  const userTemplateList = useSelector(selectUserTemplateList);

  useIonViewWillEnter(() => {
    dispatch(findUserTemplateList(id));
  });

    return (
            <>
      <IonItemDivider class="ion-margin-bottom">
        <IonLabel>
          <p>{userTemplateList.length} formularios</p>
        </IonLabel>
      </IonItemDivider>
      {userTemplateList.map((template: Template) => (
        <UserTemplateItem key={template.id} template={template} />
      ))}
    </>
    )
}